
// import MostrarVentana from "../../../../isp._comun/iu/_principal/reductores/acciones/widgets/MostrarVentana";
import ActionTypePrincipal from '../ActionTypePrincipal'

export default class PosicionarVentanaTop extends ActionTypePrincipal {
  
    ejecutar(state, nuevoEstado) {
        if (state.ventanas.length < 1) return state;

        const ventanaASubir = this.payload;
        const ventanaTop = state.ventanas[state.ventanas.length - 1];
        const esVentanaASubirTop = ventanaASubir === ventanaTop;

        if (esVentanaASubirTop) {
            return state;
        }

        const indiceVentanaASubir = state.ventanas.findIndex((ventana, indice) => {
            return ventanaASubir === ventana ? true : false;
        });

        if (indiceVentanaASubir < 0) {
            return state;
        }

        const posicionZVentanaTop = ventanaTop.posicionZ;
        for(let i=state.ventanas.length-1;i>indiceVentanaASubir;i--){
            nuevoEstado.ventanas[i].posicionZ=nuevoEstado.ventanas[i-1].posicionZ;
        }
        const ventanaASubirTemp = nuevoEstado.ventanas[indiceVentanaASubir];
        ventanaASubirTemp.posicionZ=posicionZVentanaTop;

        //Eliminar la ventanaASubir de su posicion original
        nuevoEstado.ventanas.splice(indiceVentanaASubir,1);
        // const posicion1raVentana= nuevoEstado.ventanas[0].posicionZ; 
        /* nuevoEstado.ventanas.forEach(function(ventana,index) {
            ventana.posicionZ=index+2;
        }); */
        // const ventanaTopTemp = nuevoEstado.ventanas[nuevoEstado.ventanas.length - 1];
        // ventanaASubir.posicionZ=ventanaTopTemp.posicionZ+1;
        nuevoEstado.ventanas.push(ventanaASubirTemp);


        /* const intercambiarPosicionesZ = (indice1, indice2) => {
            const posicionZIndice1 = state.ventanas[indice1].posicionZ;
            nuevoEstado.ventanas[indice1].posicionZ = state.ventanas[indice2].posicionZ;
            nuevoEstado.ventanas[indice2].posicionZ = posicionZIndice1;
        };

        const intercambiarVentanas = (indice1, indice2) => {
            const ventana1 = nuevoEstado.ventanas[indice1];
            const ventana2 = nuevoEstado.ventanas[indice2];

            nuevoEstado.ventanas.splice(indice1, 1, ventana2);
            nuevoEstado.ventanas.splice(indice2, 1, ventana1);
        };

        const indiceVentanaTop = state.ventanas.length - 1;

        intercambiarPosicionesZ(indiceVentanaASubir, indiceVentanaTop);
        intercambiarVentanas(indiceVentanaASubir, indiceVentanaTop); */

        // console.log("ventanas ", state.ventanas);
        return nuevoEstado;
        // return { ventanas: [...state.ventanas] };
    }

    ejecutar4(state, nuevoEstado) {
        if (state.ventanas.length < 1) return state;

        const ventanaASubir = this.payload;
        const ventanaTop = state.ventanas[state.ventanas.length - 1];
        const esVentanaASubirTop = ventanaASubir === ventanaTop;

        if (esVentanaASubirTop) {
            return state;
        }

        const indiceVentanaASubir = state.ventanas.findIndex((ventana, indice) => {
            return ventanaASubir === ventana ? true : false;
        });

        if (indiceVentanaASubir < 0) {
            return state;
        }
        
        //Eliminar la ventanaASubir de su posicion original
        nuevoEstado.ventanas.splice(indiceVentanaASubir,1);
        // const posicion1raVentana= nuevoEstado.ventanas[0].posicionZ; 
        nuevoEstado.ventanas.forEach(function(ventana,index) {
            ventana.posicionZ=index+2;
        });
        const ventanaTopTemp = nuevoEstado.ventanas[nuevoEstado.ventanas.length - 1];
        ventanaASubir.posicionZ=ventanaTopTemp.posicionZ+1;
        nuevoEstado.ventanas.push(ventanaASubir);


        /* const intercambiarPosicionesZ = (indice1, indice2) => {
            const posicionZIndice1 = state.ventanas[indice1].posicionZ;
            nuevoEstado.ventanas[indice1].posicionZ = state.ventanas[indice2].posicionZ;
            nuevoEstado.ventanas[indice2].posicionZ = posicionZIndice1;
        };

        const intercambiarVentanas = (indice1, indice2) => {
            const ventana1 = nuevoEstado.ventanas[indice1];
            const ventana2 = nuevoEstado.ventanas[indice2];

            nuevoEstado.ventanas.splice(indice1, 1, ventana2);
            nuevoEstado.ventanas.splice(indice2, 1, ventana1);
        };

        const indiceVentanaTop = state.ventanas.length - 1;

        intercambiarPosicionesZ(indiceVentanaASubir, indiceVentanaTop);
        intercambiarVentanas(indiceVentanaASubir, indiceVentanaTop); */

        // console.log("ventanas ", state.ventanas);
        return nuevoEstado;
        // return { ventanas: [...state.ventanas] };
    }

    ejecutar2(state, nuevoEstado) {
        if (state.ventanas.length < 1) return state;

        const ventanaASubir = this.payload;
        const ventanaTop = state.ventanas[state.ventanas.length - 1];
        const esVentanaASubirTop = ventanaASubir === ventanaTop;

        if (esVentanaASubirTop) {
            return state;
        }

        const indiceVentanaASubir = state.ventanas.findIndex((ventana, indice) => {
            return ventanaASubir === ventana ? true : false;
        });

        if (indiceVentanaASubir < 0) {
            return state;
        }

        const intercambiarPosicionesZ = (indice1, indice2) => {
            const posicionZIndice1 = state.ventanas[indice1].posicionZ;
            nuevoEstado.ventanas[indice1].posicionZ = state.ventanas[indice2].posicionZ;
            nuevoEstado.ventanas[indice2].posicionZ = posicionZIndice1;
        };

        const intercambiarVentanas = (indice1, indice2) => {
            const ventana1 = nuevoEstado.ventanas[indice1];
            const ventana2 = nuevoEstado.ventanas[indice2];

            nuevoEstado.ventanas.splice(indice1, 1, ventana2);
            nuevoEstado.ventanas.splice(indice2, 1, ventana1);
        };

        const indiceVentanaTop = state.ventanas.length - 1;

        intercambiarPosicionesZ(indiceVentanaASubir, indiceVentanaTop);
        intercambiarVentanas(indiceVentanaASubir, indiceVentanaTop);

        // console.log("ventanas ", state.ventanas);
        return nuevoEstado;
        // return { ventanas: [...state.ventanas] };
    }

      
    ejecutar3(state, nuevoEstado) {
        const idVentanaASubir = this.payload;
        const idVentanaTop = state.ventanas[state.ventanas.length - 1].id;
        const esVentanaASubirTop = idVentanaASubir === idVentanaTop;
        
        if (esVentanaASubirTop) {
            return state;
        } else {
            state.ventanas.some((ventana, indice) => {
                if (idVentanaASubir === ventana.id) {
                    // console.log("iterador");
                    // indiceVentanaAPosicionar = indice;
                    const intercambiarPosicionesZ = (indice1, indice2) => {
                        const posicionZIndice1 = state.ventanas[indice1].posicionZ;
                        state.ventanas[indice1].posicionZ = state.ventanas[indice2].posicionZ;
                        state.ventanas[indice2].posicionZ = posicionZIndice1;
                    };
    
                    const intercambiarVentanas = (indice1, indice2) => {
                        const ventana1 = state.ventanas[indice1];
                        const ventana2 = state.ventanas[indice2];
    
                        state.ventanas.splice(indice1, 1, ventana2);
                        state.ventanas.splice(indice2, 1, ventana1);
                    };
    
                    // console.log("reducer ", payload);
                    const indiceVentanaAPosicionar = indice;
                    const indiceVentanaTop = state.ventanas.length - 1;
    
                    intercambiarPosicionesZ(indiceVentanaAPosicionar, indiceVentanaTop);
                    intercambiarVentanas(indiceVentanaAPosicionar, indiceVentanaTop);
    
                    // console.log("ventanas ", state.ventanas);
                    return { ventanas: [...state.ventanas] };
                }
            });
            return state;
        }
    }
}
